import React, { Component, Fragment } from 'react';
import Decorator from '../../../../functions/decorator';
import PriceCalculator from "../../../../functions/priceCalculations";
import { ToppingImage } from '../../../../ui/primitives/ToppingImage';

export default class Topping extends Component {
    constructor(props) {
        super(props);
        this.setFirstHalf = this.setFirstHalf.bind(this);
        this.setSecondHalf = this.setSecondHalf.bind(this);
        this.setWhole = this.setWhole.bind(this);
        this.setEmpty = this.setEmpty.bind(this);
        this.isFirstHalf = this.isFirstHalf.bind(this);
        this.isSecondHalf = this.isSecondHalf.bind(this);
        this.isWhole = this.isWhole.bind(this);
        this.isEmpty = this.isEmpty.bind(this);
        this.isNotEmpty = this.isNotEmpty.bind(this);
        this.setExtra = this.setExtra.bind(this);
        this.setLight = this.setLight.bind(this);
        this.setNormal = this.setNormal.bind(this);
    }

    isEmpty() {
        try {
            if(this.props.choice.quantity > 0) {
                return false;
            }
        }catch(e) {
            console.log(this.props);
        }
        return true;
    }

    isNotEmpty() {
        return !this.isEmpty();
    }

    isFirstHalf() {
        if(this.props.choice.quantity === 0) {
            return false;
        }
        if(this.props.choice.portion === 'first-half') {
            return true;
        }
        return false;
    }

    isSecondHalf() {
        if(this.props.choice.quantity === 0) {
            return false;
        }
        if(this.props.choice.portion === 'second-half') {
            return true;
        }
        return false;
    }

    isWhole() {
        if(this.props.choice.quantity === 0) {
            return false;
        }
        if(this.props.choice.portion === 'whole') {
            return true;
        }
        return false;
    }

    setFirstHalf() {
        this.props.setFirstHalf(this.props.modifierKey);
    }

    setSecondHalf() {
        this.props.setSecondHalf(this.props.modifierKey);
    }

    setWhole() {
        this.props.setWhole(this.props.modifierKey);
    }

    setEmpty() {
        this.props.removeModifier(this.props.modifierKey);
    }

    setExtra(e) {
        e.preventDefault();
        this.props.setExtra(this.props.modifierKey);
        return false;
    }

    setLight(e) {
        e.preventDefault();
        this.props.setLight(this.props.modifierKey);
        return false;
    }

    setNormal(e) {
        e.preventDefault();
        this.props.setNormal(this.props.modifierKey);
        return false;
    }

    calculateModifierPrice() {
        const mainItem = this.props.itemGroup.items[this.props.selectedMainItem];
        const modifierPrice = PriceCalculator.calculateModifierPriceForGivenItem(mainItem, this.props.mod);
        return Decorator.formatCurrency(modifierPrice);
    }

    render() {
        const size = this.props.choice.size;
        // Striped rows to make it easier to differentiate
        // Every other row
        const bgColorOffset = this.props.toppingIndex % 2 === 1 ? 'store-blur-overlay-accent' : '';
        return (
            <Fragment>
                <div className="row pl-1">
                    <div className={'col-2'}>
                        <ToppingImage label={this.props.name} />
                    </div>
                    <div className={'col-2'}>
                        <h6>{Decorator.capitalizeFirst(this.props.name)}</h6>
                    </div>
                    <div className='col-3'>
                        {this.props.showHalf ? (
                            <Fragment>
                                <span onClick={this.setFirstHalf} className={`m-1 clickable-element larger-circle icon-left-circle ${this.isFirstHalf() ? 'store-fg-accent' : 'fg-light-gray-translucent'}`}></span>
                            </Fragment>
                        ) : ''}
                        <span onClick={this.setWhole} className={`m-1 clickable-element larger-circle icon-full-circle ${this.isWhole() ? 'store-fg-accent' : 'fg-light-gray-translucent'}`}></span>
                        {this.props.showHalf ? (
                            <Fragment>
                                <span onClick={this.setSecondHalf} className={`m-1 clickable-element larger-circle icon-right-circle ${this.isSecondHalf() ? 'store-fg-accent' : 'fg-light-gray-translucent'}`}></span>
                            </Fragment>
                        ) : ''}
                    </div>
                    {(this.isNotEmpty()) ? ( // Not empty and show double is enabled, show full selection
                        <div className="col-5 text-center">
                            <div data-role="buttongroup" className='topping-group'>
                                <div className={"row"}>
                                    {this.props.showDouble && <button onClick={this.setExtra} className={`btn btn-sm ${size === 'extra' ? 'active btn-accent' : 'btn-default'}`}><span className="text-bold">Extra</span></button>}
                                    {this.props.showDouble && <button onClick={this.setNormal} className={`btn btn-sm ${size === 'normal' ? 'active btn-accent' : 'btn-default'}`}>Normal</button>}
                                    <button onClick={this.setEmpty} className={`btn btn-sm ${!this.props.showDouble && `btn-accent`}`}><span className="text-bold">Remove</span></button>
                                </div>
                            </div>
                        </div>
                    ) : <div className='col-sm'></div> }
                </div>
                <hr className="p-0 m-0 mb-1" />
            </Fragment>
        );
    }
}

/**
 * setFirstHalf={this.props.setFirstHalfOnly} setSecondHalf={this.props.setSecondHalfOnly}
            setWhole={this.props.setWholePortion} setExtra={this.props.setExtra} setLight={this.props.setLight}
            setNormal={this.props.setNormalSize} removeModifier={this.props.props.removeModifier}
    isTopping: true
    matrixWeight: 1
    name: "Sausage"
    priceLevels: {1: 0.25, 2: 0.5, 3: 0.75, 4: 1, 5: 1.25, 6: 1.5, 7: 1.75, 8: 2, 9: 2.25, 10: 2.5}
    showDouble: true
    showHalf: true
 */
